import type { ModuleInfo } from '../Bridge';
import { Bridge } from '../Bridge';
import { once } from '../utils';
import type { Version } from '../Version';

export class StoreReviewModule {
    constructor(
        readonly bridge: Bridge,
        readonly module: ModuleInfo<'store-review', 0>,
    ) {}

    private request<T>(data: any): Promise<T> {
        return this.bridge.request(this.module.id, data);
    }

    /**
     * Since store-review@0.0.0
     */
    async requestReview() {
        await this.request({
            type: 'request review',
        });
    }
}

export class StoreReview {
    /**
     * Creates a new instance using the provided bridge.
     */
    static create = (bridge: Bridge) => {
        const module = bridge.findModule('store-review', 0);
        if (module) {
            return new StoreReview(new StoreReviewModule(bridge, module), module.version);
        }
    };

    /**
     * Returns a shared instance.
     */
    static getInstance = once(() => {
        const bridge = Bridge.getInstance();
        if (bridge) {
            return StoreReview.create(bridge);
        }
    });

    /** Requests a store review from the user. */
    readonly requestReview: () => Promise<void>;

    constructor(
        readonly module: StoreReviewModule,
        readonly version: Version,
    ) {
        this.requestReview = module.requestReview.bind(module);
    }
}
